<template>
    <div class="main">
    <nav-bar></nav-bar>
    <router-view></router-view>
    </div>
</template>
<script>
    import Navbar from './layout/Navbar.vue'
    export default {
        data: function () {
            return {

            }
        },
        components: {
            'nav-bar':Navbar
        }
    }
</script>
<style>
    .main{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// Main.vue?a00e388c